"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _clsx = _interopRequireDefault(require("clsx"));

var _framerMotion = require("framer-motion");

var _MyMessage = require("./MyMessage.styles");

var _facebookMessenger = require("../../../assets/icons/facebook-messenger");

var MyMessage = function MyMessage(_ref) {
  var children = _ref.children,
      displayReadReceipt = _ref.displayReadReceipt,
      className = _ref.className;
  return (0, _jsxRuntime.jsxs)("div", {
    css: _MyMessage.styles.base,
    className: (0, _clsx["default"])('grui flex justify-end', displayReadReceipt ? 'pr-6' : 'pr-10', className),
    children: [(0, _jsxRuntime.jsx)(_framerMotion.motion.span, {
      layout: true,
      css: _MyMessage.styles.text,
      children: children
    }), displayReadReceipt && (0, _jsxRuntime.jsx)(_facebookMessenger.Checkmark, {
      className: "grui ml-3"
    })]
  });
};

MyMessage.propTypes = {
  children: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),
  displayReadReceipt: _propTypes.bool,
  className: _propTypes.string
};
MyMessage.defaultProps = {
  children: undefined,
  displayReadReceipt: false,
  className: undefined
};
var _default = MyMessage;
exports["default"] = _default;
//# sourceMappingURL=MyMessage.js.map